import { PlanUnitUnitType, type ActivityPlanUnit } from '@linktivity/ars-neo';
import { resolveUnitAmount } from '@link/share/utils';

export interface StartingPrice {
  amount: number;
  /** The unit the price is for, e.g. 大人. */
  label: string;
}

/**
 * The "from" price on a plan card: the cheapest unit flagged
 * `includeCheapestPrice`, else the adult unit. Undefined when neither exists.
 *
 * Takes catalog units (the product's own, so the server can render it) or a
 * day's units from the calendar (priced for that day) alike.
 */
export const startingPrice = (
  units: ActivityPlanUnit[],
  showOtherCurrencies: boolean
): StartingPrice | undefined => {
  const amountOf = (unit: ActivityPlanUnit) =>
    resolveUnitAmount(unit, showOtherCurrencies);
  const candidates = units.filter(
    unit =>
      unit.includeCheapestPrice &&
      (unit.amount != null || unit.displayAmount != null)
  );
  const unit = candidates.length
    ? candidates.reduce((min, next) =>
        amountOf(next) < amountOf(min) ? next : min
      )
    : units.find(
        unit =>
          unit.unitType === PlanUnitUnitType.AgeAdult ||
          unit.unitType === PlanUnitUnitType.AgeAdultAndChild
      );
  return unit ? { amount: amountOf(unit), label: unit.name ?? '' } : undefined;
};
